import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { BreadcrumbService, ConfigService, MenuService, ThemeService } from '@core/services';

@Component({
    selector: 'app-main',
    templateUrl: './app.main.component.html',
})
export class AppMainComponent implements OnDestroy, OnInit  {

    overlayMenuActive: boolean;

    staticMenuDesktopInactive: boolean;

    staticMenuMobileActive: boolean;

    menuClick: boolean;

    search = false;

    searchClick = false;

    userMenuClick: boolean;

    topbarUserMenuActive: boolean;

    notificationMenuClick: boolean;

    topbarNotificationMenuActive: boolean;

    rightMenuClick: boolean;

    rightMenuActive: boolean;

    configActive: boolean;

    configClick: boolean;

    resetMenu: boolean;

    menuHoverActive = false;

    private unsubscribe$: Subject<void> = new Subject<void>();

    constructor(
        public configService: ConfigService,
        public breadcrumbService: BreadcrumbService,
        private menuService: MenuService,
        public themeService: ThemeService,
        ) {}

    ngOnInit(): void {
        this.staticMenuDesktopInactive = localStorage.getItem('state_static-menu')
            && (localStorage.getItem('state_static-menu') === 'sm');
    }

    ngOnDestroy(): void {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }

    onLayoutClick(): void {
        if (!this.searchClick) {
            this.search = false;
        }

        if (!this.userMenuClick) {
            this.topbarUserMenuActive = false;
        }

        if (!this.notificationMenuClick) {
            this.topbarNotificationMenuActive = false;
        }

        if (!this.rightMenuClick) {
            this.rightMenuActive = false;
        }

        if (!this.menuClick) {
            if ((this.staticMenuDesktopInactive && this.isStatic())
                || this.isSlim() || this.isHorizontal()) {
                this.menuService.reset();
            }

            if (this.overlayMenuActive || this.staticMenuMobileActive) {
                this.hideOverlayMenu();
            }

            this.menuHoverActive = false;
            this.unblockBodyScroll();
        }

        if (this.configService.configActive && !this.configClick) {
            this.configService.configActive = false;
        }

        this.searchClick = false;
        this.configClick = false;
        this.userMenuClick = false;
        this.rightMenuClick = false;
        this.notificationMenuClick = false;
        this.menuClick = false;
    }

    onMenuButtonClick(event): void {
        this.menuClick = true;
        this.topbarUserMenuActive = false;
        this.topbarNotificationMenuActive = false;
        this.rightMenuActive = false;

        if (this.isOverlay()) {
            this.overlayMenuActive = !this.overlayMenuActive;
        }

        if (this.isDesktop()) {
            this.staticMenuDesktopInactive = !this.staticMenuDesktopInactive;
            this.configService.sidebarSmallModeIsActiveSubject$.next(this.staticMenuDesktopInactive);

            localStorage.setItem('state_static-menu', this.staticMenuDesktopInactive ? 'sm' : 'lg');
        } else {
            this.staticMenuMobileActive = !this.staticMenuMobileActive;
            if (this.staticMenuMobileActive) {
                this.blockBodyScroll();
            } else {
                this.unblockBodyScroll();
            }
        }

        event.preventDefault();
    }

    onSearchClick(event): void {
        this.search = !this.search;
        this.searchClick = !this.searchClick;
    }

    onSearchHide(event): void {
        this.search = false;
        this.searchClick = false;
    }

    onMenuClick($event): void {
        this.menuClick = true;
        this.resetMenu = false;
    }

    onTopbarUserMenuButtonClick(event?): void {
        this.userMenuClick = true;
        this.topbarUserMenuActive = !this.topbarUserMenuActive;
        this.hideOverlayMenu();
        if (event) {
            event.preventDefault();
        }
    }

    onTopbarNotificationMenuButtonClick(event): void {
        this.notificationMenuClick = true;
        this.topbarNotificationMenuActive = !this.topbarNotificationMenuActive;

        this.hideOverlayMenu();

        event.preventDefault();
    }

    onRightMenuClick(event): void {
        this.rightMenuClick = true;
        this.rightMenuActive = !this.rightMenuActive;

        this.hideOverlayMenu();

        event.preventDefault();
    }

    onConfigClick(event): void {
        this.configClick = true;
    }

    isSlim(): boolean {
        return this.configService.menuMode === 'slim';
    }

    isStatic(): boolean {
        return this.configService.menuMode === 'static';
    }

    isHorizontal(): boolean {
        return this.configService.menuMode === 'horizontal';
    }

    isOverlay(): boolean {
        return this.configService.menuMode === 'overlay';
    }

    isDesktop(): boolean {
        return window.innerWidth > 1091;
    }

    isMobile(): boolean {
        return window.innerWidth <= 1091;
    }

    hideOverlayMenu(): void {
        this.overlayMenuActive = false;
        this.staticMenuMobileActive = false;
    }

    blockBodyScroll(): void {
        if (document.body.classList) {
            document.body.classList.add('blocked-scroll');
        } else {
            document.body.className += ' blocked-scroll';
        }
    }

    unblockBodyScroll(): void {
        if (document.body.classList) {
            document.body.classList.remove('blocked-scroll');
        } else {
            document.body.className = document.body.className.replace(new RegExp('(^|\\b)' +
                'blocked-scroll'.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
        }
    }

}
